// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  propertyId: __t.u64().primaryKey().name("property_id"),
  twinId: __t.string().name("twin_id"),
  name: __t.string(),
  dtdlPropertyId: __t.u64().name("dtdl_property_id"),
  componentInstanceId: __t.option(__t.u64()).name("component_instance_id"),
  relationshipInstanceId: __t.option(__t.u64()).name("relationship_instance_id"),
});
